<template>
  <div class="container">
    <div class="search">
      <el-cascader
        :placeholder="$t('search.placeholderType')"
        :options="productTypeList"
        v-model="type"
        @change="handleCascader"
        filterable
        clearable
        :props="{ checkStrictly: true }"
      ></el-cascader>
      <el-input :placeholder="$t('search.placeholderProName')" v-model="keywords"></el-input>
      <div class="button" @click="search()">{{ $t('common.search') }}</div>
    </div>
    <div class="rightContent" v-if="RecommendExhibits.length > 1">
      <div class="rightBox" v-for="(item, index) in RecommendExhibits" :key="index">
        <div class="itemBox1" @click="entryDetail(item.id)">
          <div class="titl comment">{{ item.exhibitsName }}</div>
          <div class="english comment">{{ item.column23 }}</div>
          <div class="txt">{{ item.column17 }}</div>
          <div class="backImg">
            <img :src="baseUrl + item.exhibitsCoverImg" alt="" v-if="item.exhibitsCoverImg.includes('/hz/hzupload')" />
            <img src="../../../static/占位-展品-列表.png" alt="" v-else />
          </div>
          <div class="companyName">
            <span class="leftTitle">{{ item.hzExhibitor.companyNameC }}</span>
          </div>
        </div>

        <div class="bottom">
          <span class="bottomLeft" @click="goDetail(item.id)">{{ $t('common.more') }}</span>

          <div class="bottomRight">
            <span class="nu1">
              <img src="../../../static/consultingBlack.png" alt="" @click.stop="consult(item)" />
              <div class="hoversty">{{ $t('common.consult') }}</div></span
            >

            <span class="nu2"
              ><img
                :src="item.collectStatus === 1 ? require('../../../static/collent_yello.png') : require('../../../static/collent.png')"
                @click.stop="toggle(item)"
              />
              <div class="hoversty">{{ $t('common.collect') }}</div></span
            >
          </div>
        </div>
      </div>



    </div>
    <div v-else class="boxImg">
      <img src="../../../static/empty.png" alt="" />
      <div class="promptInfo">{{ $t('search.nodata') }}</div>
    </div>
  </div>
</template>
<script>
import products from '../../../../Json/searchLists.js';
import productsEn from '../../../../Json/searchListsEn.js';
import { getProductsLists, collect } from '../../../../api/recommend.js';
import { forMat, backProductDetail } from '../../../../utils/common.js';

export default {
  data() {
    return {
      baseUrl: forMat(),
      productTypeList: null,
      type: '',
      keywords: '',
      RecommendExhibits: [],
      productDetailUrl: backProductDetail(),
    };
  },
  props: ['flag'],
  created() {
    const lang = localStorage.getItem('lang')
    if(lang == 'en'){
      this.productTypeList = productsEn
    }else {
      this.productTypeList = products;
    }
    const params = {
      value: {
        exhibitsType: [],
        keyword: '',
      },
    };
    this.getLists(params);
  },
  methods: {
    consult(item) {
      this.$router.push({
        name: 'messageDetail',
        query: {
          receiveUserId: item.hzExhibitorId,
        },
      });
    },
    goDetail(id) {
      window.location.href = this.productDetailUrl + '?id=' + id;
    },
    async toggle(item) {
      let status;
      if (item.collectStatus === 0) {
        // 要添加收藏
        status = true;
      } else if (item.collectStatus === 1) {
        status = false;
      }
      const params = {
        objId: item.id,
        flag: status,
        type: 2,
      };
      try {
        const { data } = await collect(params);
        if (data.code === 200) {
          if (item.collectStatus === 0) {
            item.collectStatus = 1;
          } else {
            item.collectStatus = 0;
          }
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getLists(params) {
      try {
        const { data } = await getProductsLists(params);
        if (data.code === 200) {
          this.RecommendExhibits = data.data.list;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    search() {
      // 搜索函数 type keywords
      const params = {
        value: {
          exhibitsType: [],
          keyword: '',
        },
      };
      if (this.type.length === 1) {
        // 一级筛选
        params.value.exhibitsType = this.type;
      }
      if (this.type.length === 2) {
        // 二级筛选
        const arr = this.productTypeList.filter((it) => it.value === this.type[0]);
        const arr1 = arr[0].children.filter((it) => it.value === this.type[1]);
        const arr2 = arr1[0].children;
        arr2.map((item) => {
          params.value.exhibitsType.push(item.value);
        });
      }
      if (this.type.length === 3) {
        // 三级筛选
        params.value.exhibitsType.push(this.type[2]);
      }
      params.value.keyword = this.keywords;
      this.getLists(params);
    },
    handleCascader() {},

      
  //跳转进入
   entryDetail(id){
       window.location.href = this.productDetailUrl + '?id=' + id;
   }

  },
  watch: {
    flag(newName, oldName) {
      const params = {
        value: {
          exhibitsType: [],
          keyword: '',
        },
      };
      this.getLists(params);
      this.type = '';
      this.keywords = '';
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  min-height: 679px;
  .search {
    display: flex;
    .button {
      width: 88px;
      height: 32px;
      background: #006fb8;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 32px;
      text-align: center;
      margin-left: 20px;
    }
  }
  .rightContent {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    width: 100%;

    .rightBox {
      margin-right: 1%;
      width: 294px;
      height: fit-content;
      background-color: white;
      margin-bottom: 28px;
      border: 1px solid #e0e0e0;
      cursor: pointer;
      position: relative;
                 
      .titl {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        padding-top: 34px;
        margin-left: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
        max-width: 250px;
       
    
      }
      .english {
        font-size: 16px;
        height: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        margin-top: 9px;
        margin-left: 24px;
        line-height: 16px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        max-width: 250px;

      }
      .txt {
        font-size: 14px;
        height: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        margin-top: 11px;
        margin-left: 24px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        line-height: 14px;
        max-width: 250px;
      }
      .backImg {
        width: 226px;
        height: 172px;
        margin: 20px 0px 0px 24px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .companyName {
        margin: 19px 24px 20px 24px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .leftTitle {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          width: 203px;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 203px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .rightIcon {
          width: 18px;
          height: 18px;
          margin-left: 6px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .bottom {
        padding: 20px;
        box-sizing: border-box;
        height: 63px;
        .bottomLeft {
          float: left;
          font-size: 16px;
          cursor: pointer;
        }
        .bottomRight {
          float: right;
          margin-right: 10px;
          .nu1 {
            img {
              cursor: pointer;
              width: 24px;
              height: 24px;
            }
            .hoversty {
              width: 80px;
              height: 30px;
              color: #fff;
              background: rgba(0, 0, 0, 0.7);
              display: none;
              text-align: center;
              position: absolute;
              right: -7px;
              bottom: 15px;
              border-radius: 10px;
              line-height: 30px;
            }
          }
          .nu1:hover .hoversty {
            display: block;
          }
          .nu2 {
            img {
              cursor: pointer;
              width: 24px;
              height: 24px;
              margin-left: 25px;
            }
            .hoversty {
              width: 40px;
              height: 28px;
              color: #fff;
              background: rgba(0, 0, 0, 0.7);
              display: none;
              text-align: center;
              position: absolute;
              right: -15px;
              bottom: 15px;
              border-radius: 10px;
              line-height: 28px;
            }
          }
          .nu2:hover .hoversty {
            display: block;
          }
        }
      }
      &:hover {
        .titl {
          color: #006fb8;
        }

        .english {
          color: #006fb8;
        }
        .bottomLeft {
          color: #006fb8;
        }
      }
    }
  }
}
</style>
<style scoped>
.el-cascader {
  line-height: 32px;
}
.el-input {
  width: 240px;
  height: 32px;
}
>>> .el-input__inner {
  width: 240px;
  margin-left: 10px;
  height: 32px;
  line-height: 32px;
}
>>> .el-input__icon {
  line-height: 32px;
}
</style>
<style lang="scss">
.boxImg {
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  img {
    width: 380px;
    height: 300px;
  }
}
</style>
